export enum ApplicationInstanceScope {
	Site = 0,
	Tenant = 1,
}
